import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import { FormattedMessage } from 'react-intl'
import {
  useProductFromQueryParam,
  useProductInput,
  checkForRedesignedBiTubeProduct,
} from '../ProductsConfiguration'
import { Grid } from '@material-ui/core'
import DownloadIcon from '@src/icons/DownloadIcon'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  containerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  content: {
    width: '40%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
  },
  icon: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(-0.5),
    marginRight: theme.spacing(2),
  },
  stroke: {
    stroke: theme.palette.primary.main,
    strokeWidth: '1px',
  },
}))

const DownloadSummary = () => {
  const classes = useStyles()
  const product = useProductFromQueryParam()
  const productInput = useProductInput()
  const isBiTube = checkForRedesignedBiTubeProduct(product)
  let url: string = ''
  if (isBiTube) {
    url = `/configurator-order/summary/bitube?product=${product}&participantId=${productInput.participantId}&locale=${productInput.locale}&country=${productInput.countryCode}`
  } else {
    url = `/configurator-order/summary/country/${productInput.participantId}/${productInput.locale}/${product}`
  }

  return (
    <div className={classes.containerWrapper}>
      <Grid container className={classes.content}>
        <Grid item className={classes.heading}>
          <Link href={url} download>
            <DownloadIcon className={clsx(classes.icon, classes.stroke)} />
            <FormattedMessage
              id="DOWNLOAD_PRINT_SUMMARY"
              defaultMessage="Download Summary"
            />
          </Link>
        </Grid>
      </Grid>
    </div>
  )
}
export default DownloadSummary
